export default __webpack_public_path__ + "static/media/settingsIcon.a63d4890.svg";